module.exports = __webpack_public_path__ + "static/media/img_1-5_264insig.acd9a603.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_1-5_264insig.svg
// module id = 677
// module chunks = 0